import { render, staticRenderFns } from "./asset-header.vue?vue&type=template&id=ae0074c4&scoped=true&"
import script from "./asset-header.vue?vue&type=script&lang=js&"
export * from "./asset-header.vue?vue&type=script&lang=js&"
import style0 from "./asset-header.vue?vue&type=style&index=0&id=ae0074c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0074c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0074c4')) {
      api.createRecord('ae0074c4', component.options)
    } else {
      api.reload('ae0074c4', component.options)
    }
    module.hot.accept("./asset-header.vue?vue&type=template&id=ae0074c4&scoped=true&", function () {
      api.rerender('ae0074c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-header.vue"
export default component.exports